import { matchCategory } from './matchCategory';
import styles from './ScoreRing.module.css';

interface ScoreRingProps {
  /** 0–100. */
  score: number;
  /** Текстовая расшифровка рядом с числом — цвет не единственный носитель смысла. */
  label: string;
  size?: number | undefined;
  title?: string | undefined;
}

const STROKE = 6;

export function ScoreRing({ score, label, size = 76, title }: ScoreRingProps) {
  const bounded = Math.max(0, Math.min(100, Math.round(score)));
  const radius = (size - STROKE) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (bounded / 100) * circumference;
  const category = matchCategory(bounded);

  return (
    <div className={styles.wrapper}>
      <div
        className={[styles.ring, styles[category]].join(' ')}
        style={{ width: size, height: size }}
      >
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
          <circle
            className={styles.track}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={STROKE}
            fill="none"
          />
          <circle
            className={styles.value}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={STROKE}
            strokeLinecap="round"
            fill="none"
            strokeDasharray={`${dash} ${circumference - dash}`}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
        </svg>
        <span className={`${styles.number} tabular`}>{bounded}</span>
      </div>
      <span className={styles.label}>
        {title ? <span className={styles.title}>{title}</span> : null}
        {label}
      </span>
    </div>
  );
}
